
import { authFetch } from "../../../../../api";

export const getassignments = async (userId) => {
  try {
    const response = await authFetch(`stm-route/assignments/${userId}`, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    
    });

    let data;

    data = await response.json();
    return data;
  } catch (err) {
    console.error("cant find assigments:", err.message);
  }
};



export const uploadAssignment = async (requestData) => {
  try {
    const response = await authFetch("stm-route/upload-assignment", {
      method: "POST",
    //   headers: { "Content-Type": "application/json" },
      body: requestData,
    });

    let data;

    data = await response.json();
    return data;
  } catch (err) {
    console.error("Error creating course:", err.message);
  }
};